import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { FAQ } from "../common";
import { Hero } from "./components/hero/Hero";
import { Benefits } from "./components/benefits/Benefits";
import { SideImage } from "./components/side-image/SideImage";
import { HowToPay } from "./components/how-to-pay/HowToPay";

type QuestionAnswer = {
  _uid: string;
  title: string;
  text: string;
};

export const ApplePay: FC = () => {
  const { t } = useTranslation("p_bank_apple-pay");

  return (
    <>
      <Hero />
      <div
        className={classNames(
          "flex flex-col items-center px-5 pb-20",
          "lg:px-16 lg:pb-25",
          "xl:px-24 xl:pb-40",
        )}
      >
        <Benefits />
        <SideImage />
        <HowToPay />
        <FAQ
          title={t("faq_header")}
          questionsPool={t("faq", { returnObjects: true }) as QuestionAnswer[]}
        />
      </div>
    </>
  );
};
